<template>
    <div class="wrapper">
        <section id="specialMessages">
            <h2>Special Messages</h2>

            <custom-input type="toggle" name="toggleCrisisMessage" label="Turn on/off" v-model="enabled"/>

            <section v-show="enabled">
                <div class="errors" v-if="$validator.errors && $validator.errors.has('crisisMessage')">
                    <small v-for="(error, index) in $validator.errors.collect('crisisMessage')" v-bind:key="index">
                        {{ error }}
                    </small>
                </div>

                <div class="row datetimes">
                    <custom-input id="crisisMessageStart" type="datetime" name="crisisMessageStart" placeholder="start" v-model="crisisMessage.start" @input="validateCrisisMessageTime(crisisMessage)"/>
                    <custom-input id="crisisMessageEnd" type="datetime" name="crisisMessageEnd" placeholder="end" v-model="crisisMessage.end" @input="validateCrisisMessageTime(crisisMessage)"/>
                </div>

                <custom-input type="textarea" name="crisisMessageTextNL" label="Message Text - NL" placeholder="Message" v-model="crisisMessage.NL"/>
                <custom-input type="textarea" name="crisisMessageTextEN" label="Message Text - EN" placeholder="Message" v-model="crisisMessage.EN"/>
            </section>
        </section>

        <button class="primary" @click="saveConfig">Save</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput';

export default {
    name: 'settingsSpecialMessages',
    mixins: [
        Default
    ],
    components: {
        customInput
    },
    inject: {
        $validator: '$validator'
    },
    data() {
        return {
            blockValidation: true,
            enabled: false,
            crisisMessage: {
                start: '',
                end: '',
                NL: '',
                EN: ''
            }
        };
    },
    mounted() {
        this.blockValidation = false;
        this.getConfig();
    },
    methods: {
        validateCrisisMessageTime: function(crisisMessage) {
            if (this.blockValidation)
                return false;

            this.$validator.errors.remove('crisisMessage');

            if (((crisisMessage.start && crisisMessage.end) && crisisMessage.start >= crisisMessage.end) ||
                    (!crisisMessage.start || !crisisMessage.end)) {
                this.$validator.errors.add({
                    field: 'crisisMessage',
                    msg: 'Invalid time range'
                });
                return false;
            } else
                return true;
        },
        saveConfig: function() {
            if (!this.enabled) {
                this.crisisMessage.start = '';
                this.crisisMessage.end = '';
                this.crisisMessage.EN = '';
                this.crisisMessage.NL = '';
            } else if (!this.validateCrisisMessageTime(this.crisisMessage))
                return false;

            const startTime = this.crisisMessage.start ? new Date(this.crisisMessage.start).getTime() / 1000 : '';
            const endTime = this.crisisMessage.end ? new Date(this.crisisMessage.end).getTime() / 1000 : '';

            return new Promise((resolve) => {
                return this.$http.put('v1.1/config', {
                    crisisMessageTextNL: this.crisisMessage.NL,
                    crisisMessageTextEN: this.crisisMessage.EN,
                    crisisMessageStartTime: startTime,
                    crisisMessageEndTime: endTime
                }).then(response => {
                    // Success callback
                    if (!response.data.data.success)
                        this.$parleyAdmin.queryErrors.addError('Something went wrong while saving the special messages configuration, please try again later');
                    else
                        this.$parleyAdmin.queryErrors.addError('Special messages configuration saved successfully', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while saving the special messages configuration, please try again later');
                    resolve(false);
                });
            });
        },
        getConfig: function() {
            return new Promise((resolve) => {
                return this.$http.get('v1.1/config').then(response => {
                    // Success callback

                    if (response.data.data.crisisMessageTextNL ||
                            response.data.data.crisisMessageTextEN ||
                            response.data.data.crisisMessageStartTime ||
                            response.data.data.crisisMessageEndTime)
                        this.enabled = true;

                    // Save crisis message
                    this.crisisMessage.NL = response.data.data.crisisMessageTextNL;
                    this.crisisMessage.EN = response.data.data.crisisMessageTextEN;
                    if (response.data.data.crisisMessageStartTime > 0)
                        this.crisisMessage.start = new Date(parseInt(response.data.data.crisisMessageStartTime * 1000)).toISOString();
                    if (response.data.data.crisisMessageEndTime > 0)
                        this.crisisMessage.end = new Date(parseInt(response.data.data.crisisMessageEndTime * 1000)).toISOString();

                    resolve(true);
                }, response => {
                    // Error callback
                    this.$parleyAdmin.queryErrors.addError('Something went wrong while retrieving the special messages configuration, please try again later');
                    resolve(false);
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 50%;
        max-width: 34em;

        section {
            margin-bottom: 1em;
        }

        #specialMessages {
            .datetimes {
                .custom-input {
                    width: 12em;

                    &:nth-child(1) {
                        margin-right: 1em;
                    }
                }
            }
        }

        .errors {
            color: red;
        }
    }
</style>
